import { ReactElement, useState } from 'react';
import { CircularProgress } from '@mui/material';

import { useRequest } from '~hooks/useRequest';
import { Nullable } from '~globals/types';
import { getSettlementBillingItemMetaData } from '~services/billingItem';
import { SettlementBillingItemMetaData } from '~services/billingItem/types';

import DialogGenerateLiquidationtProvider from './Context';
import { DialogGenerateLiquidationProps } from './types';
import DialogGenerateLiquidationContent from './Content';
import {
  DialogGenerateLiquidationContainer,
  DialogGenerateLiquidationLoadingContainer,
} from './styles';

const DialogGenerateLiquidation = ({
  open,
  onClose,
  liquidationData,
  onSuccesGenerate,
}: DialogGenerateLiquidationProps): ReactElement => {
  const [metadata, setMetada] =
    useState<Nullable<SettlementBillingItemMetaData>>(null);

  const [, loadingGeneralInfo] = useRequest({
    request: getSettlementBillingItemMetaData,
    payload: null,
    withPostSuccess: (response) => {
      const currentMetadata = response.data
        ?.data as SettlementBillingItemMetaData;

      setMetada(currentMetadata);
    },
  });

  return (
    <DialogGenerateLiquidationContainer open={open}>
      {loadingGeneralInfo && (
        <DialogGenerateLiquidationLoadingContainer>
          <CircularProgress color="primary" disableShrink size={80} />
        </DialogGenerateLiquidationLoadingContainer>
      )}

      {!loadingGeneralInfo && metadata && (
        <DialogGenerateLiquidationtProvider
          metadata={metadata}
          liquidationData={liquidationData}
          open={open}
          onClose={onClose}
          onSuccesGenerate={onSuccesGenerate}
        >
          <DialogGenerateLiquidationContent />
        </DialogGenerateLiquidationtProvider>
      )}
    </DialogGenerateLiquidationContainer>
  );
};

export default DialogGenerateLiquidation;
